import { gsap } from 'gsap';

const vAlert = () => {
    const alertBars = document.querySelectorAll('.v-alert');
    if (!alertBars.length) {
        return;
    }

    alertBars.forEach(alertBar => {
        let alertID = alertBar.dataset.id;
        if (!alertID) {
            return;
        }

        const close = alertBar.querySelector('.v-alert__close');
        close.addEventListener('click', () => {
            gsap.to(alertBar, {
                duration: 0.4,
                height: 0,
                onComplete: () => {
                    alertBar.classList.add('v-alert--hidden');
                    alertBar.removeAttribute('style');
                    localStorage.setItem(`wb-alert-${alertID}`, 'dismissed');
                },
            });
        });

        alertID = alertID.replace(' ', '-');
        const wasShown = sessionStorage.getItem(`wb-alert-${alertID}`);
        const isDismissable = alertBar.dataset.dismissable;
        const wasDismissed = localStorage.getItem(`wb-alert-${alertID}`);

        if ((wasShown && isDismissable) || wasDismissed) {
            return;
        }

        alertBar.classList.remove('v-alert--hidden');
        sessionStorage.setItem(`wb-alert-${alertID}`, 'seen');
    }); 
};

export default vAlert;
